import React from "react";
import { withRouter } from "react-router-dom";

import HeadText from "../../../../../components/components-text/head-text";
import NoteText from "../../../../../components/components-text/note-text";
import Title03Text from "../../../../../components/components-text/title-03-text";
import WebText from "../../../../../components/components-text/web-text";
import MainTable from "../../../../../components/main-table";
import MainButton from "../../../../../components/main-button";
import LeftInfoModal from "../../../../../components/left-info-modal";
import { StepsTravel, TravelHireMenuHelper } from "../../../../../components/travel-hire-menu";
import { TravelResultDataContainer } from "./travel-result-data-style";
import { images } from "../../../../../assets";

import { SPANISH_COUNTRY_OPTION } from "../../../../../constants/optionsTravelPolicy";
import { withCoverages } from "../../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../../context/mixin/with-general";
import { withPolicy } from "../../../../../context/mixin/with-policy";
import { withDynamicProducts } from "../../../../../context/mixin/with-dynamic-products";
import { withPayTypes } from "../../../../../context/mixin/with-pay-types";

import TravelServices from "../../../../../services/TravelServices";
import {
  getGuaranteeTableRowsTravel,
  getPaymentTableRows,
  GuaranteeTableColumns,
  PaymentTableColumns,
} from "./travel-result-helpers";
import { deepGet, formatter } from "../../../../../utils/utility";
import { TravelResultProps, TravelResultState } from "./travel-result-types";

class TravelResultDataLayout extends React.Component<TravelResultProps, TravelResultState> {
  constructor(props: TravelResultProps) {
    super(props);

    this.state = {
      infoModal: {
        active: false,
        mainTitle: "",
        mainText: "",
        list: [],
      },
    };
  }

  componentDidMount = async () => {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);
  };

  componentWillReceiveProps(nextProps: TravelResultProps) {
    if (nextProps.resumeHiring) {
      this.resumeHiring();
    }
  }

  resumeHiring = async () => {
    const { data } = this.props;
    const response = await TravelServices.hiring({
      setLoading: this.props.setLoading,
      data: {
        COTIZACION: data.idcotiza,
        PAGO_POLIZA: {
          MEDIO_PAGO: data.payment.paymentMethod,
          EXISTE_MANDATO_COBRO: "N",
        },
        EMISION_POLIZA: "N",
        PAYGOLD: "S",
      },
    });

    if (response.ok) {
      const warns: string[] = [];
      const responseWarnings = response.data.header.warnings;
      if (Array.isArray(responseWarnings)) {
        responseWarnings.forEach((item) => warns.push(item.message));
      }
      this.props.data.emisionError = warns;
      this.props.data.paymentSent = true
      this.props.saveHiring(true);
      this.setState({
        infoModal: {
          active: true,
          mainTitle: "La solicitud ha sido enviada.",
          mainText: "La solicitud queda pendiente del pago.",
          list: warns,
        },
      });
    } else {
      this.setState({
        infoModal: {
          active: true,
          mainTitle: "La solicitud no se ha podido tramitar.",
          mainText: response.message,
        },
      });
    }
  };

  render() {
    const { data, policy, travelCountries, allPayTypes } = this.props;
    const productType = deepGet(policy, "product.products_internalName", "") || "";
    const total = deepGet(data, "priceData.price.totalPremium");

    const paymentTableRows = getPaymentTableRows({ allPayTypes, data }) || [];
    const guaranteeTableRows = getGuaranteeTableRowsTravel({ data }) || [];

    return (
      <TravelResultDataContainer>
        <div className="data-flow-status-title">
          <h2>DETALLE PREVIO DE LA CONTRATACIÓN</h2>
        </div>

        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h3>DATOS DEL SEGURO</h3>
          </div>
        </div>

        <div className="result-simulation-special">
          <div className="result-simulation-special-title">
            <Title03Text>
              <p>Nº {data.idcotiza || data.requestNumber}</p>
            </Title03Text>
            <div>
              <p className="price">{total && formatter.format(Number(total))}</p>
            </div>
          </div>
          <div className="result-simulation-special-container">
            <div className="result-simulation-special-item">
              <HeadText>
                <p>{policy.product.products_name ? policy.product.products_name : ""}</p>
              </HeadText>
            </div>
            <div className="result-simulation-special-item">
              <div className="result-simulation-special-subitem">
                <div className="result-simulation-special-subitem-title">
                  <NoteText>
                    <p>FECHA EMISIÓN</p>
                  </NoteText>
                </div>
                <div className="result-simulation-special-subitem-content">
                  <WebText>
                    <p>{data.starterDay}</p>
                  </WebText>
                </div>
              </div>
              <div className="result-simulation-special-subitem">
                <div className="result-simulation-special-subitem-title">
                  <NoteText>
                    <p>DELEGACIÓN</p>
                  </NoteText>
                </div>
                <div className="result-simulation-special-subitem-content">
                  <WebText>
                    <p>{data.mediatorUser.delegation}</p>
                  </WebText>
                </div>
              </div>
              <div className="result-simulation-special-subitem">
                <div className="result-simulation-special-subitem-title">
                  <NoteText>
                    <p>MEDIADOR</p>
                  </NoteText>
                </div>
                <div className="result-simulation-special-subitem-content">
                  <WebText>
                    <p>{data.mediatorUser.code}</p>
                  </WebText>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="result-simulation-item float">
          <div className="result-simulation-special-title">
            <Title03Text>
              <p>Cliente</p>
            </Title03Text>
          </div>
          <div className="result-simulation-special">
            <div className="result-hiring-special-container col-100">
              <div className="result-hiring-special-first-item col-30">
                <HeadText>
                  <p>Datos del Viaje</p>
                </HeadText>
              </div>
              <div className="result-hiring-special-item col-70">
                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Destino</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>
                          {data.taker &&
                          data.taker.policy &&
                          data.taker.policy.travelDestination &&
                          Object.keys(travelCountries).length
                            ? travelCountries[data.taker.policy.travelDestination]
                            : SPANISH_COUNTRY_OPTION}
                        </p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Fecha inicio</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker && data.taker.policy && data.taker.policy.departureDate}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Fecha fin</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker && data.taker.policy && data.taker.policy.returnDate}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className=""></div>
                </div>

                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-50">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Cantidad de pasajeros</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.insureds && data.insureds.length}</p>
                      </WebText>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="result-simulation-special">
            <div className="result-hiring-special-title">
              <Title03Text>
                <p>Tomador</p>
              </Title03Text>
            </div>
            <div className="result-hiring-special-container col-100">
              <div className="result-hiring-special-first-item col-30">
                <HeadText>
                  <p>
                    {data.taker.name
                      ? `${data.taker.name} ${data.taker.lastname1} ${data.taker.lastname2}`
                      : ""}
                  </p>
                </HeadText>
              </div>
              <div className="result-hiring-special-item col-70">
                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Tipo documento</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>
                          {data.taker.docType}{" "}
                          {data.taker.physicalPerson ? "Persona física" : "Persona jurídica"}
                        </p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Nº documento</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.docNumber}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Género</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>
                          {data.taker.gender
                            ? data.taker.gender === "H"
                              ? "Hombre"
                              : "Mujer"
                            : ""}
                        </p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Fecha de nacimiento</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.birthDate}</p>
                      </WebText>
                    </div>
                  </div>
                </div>

                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>DOMICILIO</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>
                          {data.taker.address
                            ? data.taker.address.address.value + ", " + data.taker.address.number
                            : ""}
                        </p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>LOCALIDAD</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.address ? data.taker.address.town.value : ""}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>PROVINCIA</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.address ? data.taker.address.province.value : ""}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>CÓDIGO POSTAL</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.address ? data.taker.address.postalCode : ""}</p>
                      </WebText>
                    </div>
                  </div>
                </div>

                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Email</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.email}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Teléfono fijo</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.landlinePhone}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Teléfono móvil</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{data.taker.mobilePhone}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="col-20"></div>
                </div>

                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>FECHA CONSENTIMIENTO</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{deepGet(data, "protectionData.consentDate")}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-20">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>CESIÓN DE DATOS</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{deepGet(data, "protectionData.dataTransfer") === "S" ? "SI" : "NO"}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className="result-hiring-special-subitem col-40">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>ENVÍO DE PUBLICIDAD DE TERCEROS</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>{deepGet(data, "protectionData.thirdParty") === "S" ? "SI" : "NO"}</p>
                      </WebText>
                    </div>
                  </div>
                  <div className=""></div>
                </div>

                <div className="result-hiring-special-row">
                  <div className="result-hiring-special-subitem col-50">
                    <div className="result-simulation-special-subitem-title">
                      <NoteText>
                        <p>Cesión de llamadas promocionando productos de terceros</p>
                      </NoteText>
                    </div>
                    <div className="result-hiring-special-subitem-content">
                      <WebText>
                        <p>
                          {deepGet(data, "protectionData.thirdPartyCalls") === "S" ? "SI" : "NO"}
                        </p>
                      </WebText>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="result-simulation-item float">
          <div className="result-simulation-special-title">
            <Title03Text>
              <p>Asegurados</p>
            </Title03Text>
          </div>
          {data.insureds &&
            data.insureds.map((insured) => {
              return (
                <div key={insured.docNumber} className="result-hiring-special-container col-100">
                  <div className="result-hiring-special-first-item col-30">
                    <HeadText>
                      <p>
                        {insured.name
                          ? `${insured.name} ${insured.lastname1} ${insured.lastname2}`
                          : ""}
                      </p>
                    </HeadText>
                  </div>
                  <div className="result-hiring-special-item col-70">
                    <div className="result-hiring-special-row">
                      <div className="result-hiring-special-subitem col-40">
                        <div className="result-simulation-special-subitem-title">
                          <NoteText>
                            <p>Tipo documento</p>
                          </NoteText>
                        </div>
                        <div className="result-hiring-special-subitem-content">
                          <WebText>
                            <p>{insured.docType}</p>
                          </WebText>
                        </div>
                      </div>
                      <div className="result-hiring-special-subitem col-20">
                        <div className="result-simulation-special-subitem-title">
                          <NoteText>
                            <p>Nº documento</p>
                          </NoteText>
                        </div>
                        <div className="result-hiring-special-subitem-content">
                          <WebText>
                            <p>{insured.docNumber}</p>
                          </WebText>
                        </div>
                      </div>
                      <div className="result-hiring-special-subitem col-20">
                        <div className="result-simulation-special-subitem-title">
                          <NoteText>
                            <p>Género</p>
                          </NoteText>
                        </div>
                        <div className="result-hiring-special-subitem-content">
                          <WebText>
                            <p>{insured.gender === "H" ? "Hombre" : "Mujer"}</p>
                          </WebText>
                        </div>
                      </div>
                      <div className="result-hiring-special-subitem col-20">
                        <div className="result-simulation-special-subitem-title">
                          <NoteText>
                            <p>Fecha de nacimiento</p>
                          </NoteText>
                        </div>
                        <div className="result-hiring-special-subitem-content">
                          <WebText>
                            <p>{insured.birthDate}</p>
                          </WebText>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <div className="result-simulation-item float">
          <div className="result-simulation-special-title">
            <Title03Text>
              <p>Garantías</p>
            </Title03Text>
          </div>
          <div className="detail-pendant-simulation-item-content">
            <div className="detail-pendant-simulation-item-content-table">
              <MainTable
                className="table noZebra"
                columns={GuaranteeTableColumns}
                rows={guaranteeTableRows}
                keysRow={["coverages", "capital"]}
              />
            </div>
          </div>
        </div>

        <div className="result-simulation-item float">
          <div className="result-simulation-special-title">
            <Title03Text>
              <p>Desglose por forma de pago</p>
            </Title03Text>
          </div>
          <div className="detail-pendant-simulation-item-content">
            <div className="detail-pendant-simulation-item-content-table">
              <MainTable
                className="table noZebra"
                columns={PaymentTableColumns}
                rows={paymentTableRows}
                keysRow={["periodicity", "netPremium", "taxs", "total"]}
              />
            </div>
          </div>
        </div>

        <div className="colSin-100">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab
                icon
                type="white"
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={() =>
                  this.props.history.push(
                    TravelHireMenuHelper.getPreviousStepNavigationPath(
                      StepsTravel.DetallePrevioContratacion,
                      productType
                    )
                  )
                }
              />
            </div>
          </div>
        </div>

        <LeftInfoModal
          img={images.IconUserBlue}
          className=""
          mainTitle={this.state.infoModal.mainTitle}
          mainText={this.state.infoModal.mainText}
          buttonText={"Aceptar"}
          noSecondaryButton
          active={this.state.infoModal.active}
          list={this.state.infoModal.list}
          onClickAccept={() => this.props.history.push("/contratacion/pendiente")}
          close={() => this.props.history.push("/contratacion/pendiente")}
        />
      </TravelResultDataContainer>
    );
  }
}

export default withDynamicProducts(
  withCoverages(withPayTypes(withPolicy(withGeneral(withRouter(TravelResultDataLayout)))))
);
